export const GET_ALL_NOTIFICATION = "GET_ALL_NOTIFICATION";
export const AllCountTotalUnseenMessagesConst="AllCountTotalUnseenMessages"
export const GetUnseenNotificationCountConst="GetUnseenNotificationCount"